export function isExperimentalEnabled() {
  return process.env.NEXT_PUBLIC_EXPERIMENTAL_FEATURES_ENABLED === 'true'
}

export function forceTaskCreation() {
  return process.env.NEXT_PUBLIC_FORCE_TASK_CREATION === 'true'
}

export function isDebugModeEnabled() {
  return process.env.NEXT_PUBLIC_DEBUG_MODE === 'true'
}

export function isForceHasWebsiteSubscriptionEnabled() {
  return process.env.NEXT_PUBLIC_FORCE_HAS_WEBSITE_SUBSCRIPTION === 'true'
}

export function isForceHasIntelligentWebsiteSubscriptionEnabled() {
  return process.env.NEXT_PUBLIC_FORCE_HAS_INTELLIGENT_WEBSITE_SUBSCRIPTION === 'true'
}

export function isForceHasGlamDeskSubscriptionEnabled() {
  return process.env.NEXT_PUBLIC_FORCE_HAS_GLAMDESK_SUBSCRIPTION === 'true'
}

export function isFakeDelays() {
  return process.env.NEXT_PUBLIC_USE_FAKE_DELAYS === 'true'
}

export function isMockReportDataEnabled() {
  return process.env.NEXT_PUBLIC_MOCK_REPORT_DATA === 'true'
}

export const GLAMMATIC_ENV_DEVELOPMENT = 'development'
export const GLAMMATIC_ENV_SANDBOX = 'sandbox'
export const GLAMMATIC_ENV_PRODUCTION = 'production'

function getGlammaticEnv(): string | undefined {
  return process.env.GLAMMATIC_ENV || process.env.NEXT_PUBLIC_GLAMMATIC_ENV
}

export function isDevelopmentGlammaticEnv(): boolean {
  return getGlammaticEnv() === GLAMMATIC_ENV_DEVELOPMENT
}

export function isSandboxGlammaticEnv(): boolean {
  return getGlammaticEnv() === GLAMMATIC_ENV_SANDBOX
}

export function isProductionGlammaticEnv(): boolean {
  return getGlammaticEnv() === GLAMMATIC_ENV_PRODUCTION
}

export const GLAM_DESK_PRODUCTION_URL = 'https://desk.glammatic.com/'
export const GLAM_DESK_NON_PRODUCTION_URL = 'https://glamdesk.vercel.app/'

export function getGlamDeskUrl(): string {
  return isProductionGlammaticEnv() ? GLAM_DESK_PRODUCTION_URL : GLAM_DESK_NON_PRODUCTION_URL
}
